import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { LogOut, User } from "lucide-react";
import { useAuth } from "../contexts/useAuth.jsx";
import { useTranslation } from "../contexts/TranslationContext.jsx";

// Avatar no header do app: ao clicar, abre dropdown com email, créditos e ações.
export function UserMenu({ onLogout }) {
  const { t } = useTranslation();
  const { email, credits } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (isOpen && containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <div ref={containerRef} className="relative">
      <button
        onClick={() => setIsOpen((v) => !v)}
        aria-label={email}
        className={`hidden md:flex items-center justify-center w-9 h-9 rounded-lg border transition ${
          isOpen
            ? "bg-brand-500/10 border-brand-500/40 text-brand-400"
            : "bg-white/5 border-white/10 text-gray-300 hover:bg-white/10 hover:text-white"
        }`}
      >
        <User size={18} />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-60 bg-[#1a1a1a] border border-white/10 rounded-lg shadow-xl overflow-hidden z-[60]">
          {/* Detalhes da conta */}
          <div className="px-4 py-3 border-b border-white/10">
            <p className="text-sm text-gray-200 font-medium truncate">{email}</p>
            <p className="text-xs text-gray-400 mt-0.5">
              {credits} {t("nav.credits")}
            </p>
          </div>

          <Link
            to="/profile"
            onClick={() => setIsOpen(false)}
            className="flex items-center gap-3 px-4 py-3 hover:bg-white/5 text-sm text-gray-300 hover:text-white transition"
          >
            <User size={18} />
            {t("nav.profile")}
          </Link>
          <button
            onClick={() => {
              setIsOpen(false);
              onLogout();
            }}
            className="w-full flex items-center gap-3 px-4 py-3 hover:bg-red-500/10 text-sm text-red-400 hover:text-red-300 transition border-t border-white/5"
          >
            <LogOut size={18} />
            {t("nav.logout")}
          </button>
        </div>
      )}
    </div>
  );
}
